<template lang="html">
	<ag-table :columns="columnDefs" :rows="rowDataFiltered" :customOptions="tableOptions" @cellclick="handleCellClick"></ag-table>
</template>

<script>
import AgTable from '@/common/components/ag-table'
export default {
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable
	},
	data () {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44,
			}
		}
	},
	beforeMount () {
		this.columnDefs = [
			{ name: 'Pic-id', field: 'picture', cellType: 'roundImg', width: 80 },
			{ name: 'Nom', field: 'name', width: 150 },
			{ name: 'Cabinet', field: 'office.name', width: 120 },
			{ name: 'E-mail', field: 'email', cellType: 'light', width: 250 },
			{ name: 'Téléphone', field: 'phone', cellType: 'light', width: 120 },
			{ name: 'Adresse', field: 'address', cellType: 'light', width: 150 },
			{ name: 'Ville', field: 'city', cellType: 'light', width: 100 },
			{ name: 'Pays', field: 'country', cellType: 'light', width: 100 },
      { name: 'Conseiller', field: 'advisor', width: 100 },
			{ name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 100 }
		]
	},
	methods: {
		handleCellClick (e) {
			console.log(this.clickable, e.data, e.data.id)
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e)
			} else if (this.clickable && e.data && e.data.id) {
				console.log('I should move')
				this.$router.push({name: 'ClientsDetails', params: {id: e.data.id}})
			}
		}
	},
	computed: {
		rowDataFiltered () {
			return this.elements.map(client => ({
				...client,
				name: `${client.first_name} ${client.last_name}`
			}))
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ClientsTable.vue?6eb472a6